import React from 'react';
import { Box, Typography } from '@mui/material';

// Label above the input, helper below, red border + message on error. Every
// form field uses this wrapper (including custom, non-TextField controls
// like a colour picker or a category select) so inline validation is
// consistent everywhere. A plain MUI TextField already gets the same
// label/helperText look from the theme; FieldRow exists for everything else.
const FieldRow = ({ label, helper, error, required, children, sx }) => (
  <Box sx={{ mb: 1.5, ...sx }}>
    {label && (
      <Typography variant="subtitle2" component="label" sx={{ display: 'block', mb: 0.5 }}>
        {label}{required && ' *'}
      </Typography>
    )}
    <Box
      sx={error ? {
        '& .MuiOutlinedInput-root fieldset, & > .MuiBox-root': { borderColor: 'error.main' },
      } : undefined}
    >
      {children}
    </Box>
    {(error || helper) && (
      <Typography variant="caption" color={error ? 'error.main' : 'text.secondary'} sx={{ display: 'block', mt: 0.5 }}>
        {error || helper}
      </Typography>
    )}
  </Box>
);

export default FieldRow;
